import { jsS } from "@pnp/common";
export function body(o, previous) {
    return Object.assign({ body: jsS(o) }, previous);
}
export function headers(o, previous) {
    return Object.assign({ headers: o }, previous);
}
//# sourceMappingURL=request-builders.js.map